	<div id="maxbid_box" class="w2-maxbid-box col-xs-12 text-center" style="display:{{displayMaxBidBox}}">
		<div class="row" style="display:{{displayMaxBid}}">
			<div class="col-xs-12">
				<div id="maxbid_maxBidMessage" class="input-group">
					{{{currentMaxBidText}}} <strong>{{{maxBidFormatted}}}</strong>
				</div>
			</div>
		</div>
	</div>
